const formatMoney = val => (
  val
    ? `$${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(/(\d.+\.\d)/, '$10')}`
    : 0
);

export default formatMoney;
